import { Trait } from '../../trait.type';
import { ModifierPriority } from '../../modifier.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';

export class ShadowWalkerTrait extends Trait {
  static baseType = TraitType.ShadowWalker;
  static baseTitle = 'Shadow Walker';
  static baseText = 'When receiving damage while stealthed, reduce the damage to 0.';
  static baseIcon = 'trait';

  type = ShadowWalkerTrait.baseType;
  title = ShadowWalkerTrait.baseTitle;
  text = ShadowWalkerTrait.baseText;
  icon = ShadowWalkerTrait.baseIcon;

  init(): void {
    this.priority = ModifierPriority.First;
  }

  damageIn(damage: any): void {
    const stealth = this.owner.statusEffects.find(
      (modifier: any) => modifier.type === StatusEffect.Stealth,
    );
    if (stealth) {
      damage.value = 0;
      stealth.removeStacks(1);
    }
  }
}

TraitRegistry.register(ShadowWalkerTrait.baseType, ShadowWalkerTrait);
